import { render, staticRenderFns } from "./SoundWave.vue?vue&type=template&id=2705cdfc"
import script from "./SoundWave.vue?vue&type=script&lang=js"
export * from "./SoundWave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2705cdfc')) {
      api.createRecord('2705cdfc', component.options)
    } else {
      api.reload('2705cdfc', component.options)
    }
    module.hot.accept("./SoundWave.vue?vue&type=template&id=2705cdfc", function () {
      api.rerender('2705cdfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/SoundWave.vue"
export default component.exports